import Registry from "./Registry";
export default Registry;